import pembentukan2Bernice78 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 1-Bernice-78 Large.jpeg";
import pembentukan2Stevan81 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Stevan Antonius-81 Large.jpeg";
import pembentukan2Andrew163 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Andrew Su-163 Large.jpeg";
import pembentukan2Andrew115 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Andrew Su-115 Large.jpeg";
import pembentukan2Cinta116 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Cinta_116 Large.jpeg";
import pembentukan2Kenzie258 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan-Hari-2_Kenzie-Andhika-Theodorus-Suhanto_258-Large.jpeg";
import pembentukan2Cinta77 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Cinta_77 Large.jpeg";
import pembentukan2Devin196 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Devin Edsel_196 Large.jpeg";
import pembentukan2Devin299 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Devin Edsel_299 Large.JPG";
import pembentukan2Johan92 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Johan_92 Large.jpeg";
import pembentukan2Johan118 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Johan_118 Large.jpeg";
import pembentukan2Kelvin273 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Kelvin Kurniawan_273 Large.jpeg";
import pembentukan2Kelvin297 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Kelvin Kurniawan_297 Large.jpeg";
import pembentukan2Bernice108 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 1-Bernice-108 Large.jpeg";
import pembentukan2Kenzie264 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Kenzie Andhika Theodorus Suhanto_264 Large.jpg";
import pembentukan2Kenzie314 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Kenzie Andhika Theodorus Suhanto_314 Large.jpeg";
import pembentukan2Kia13 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Kia_13 Large.jpeg";
import pembentukan2Kia31 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Kia_31 Large.jpeg";
import pembentukan2Ravalen095 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Ravalen Virginia_095 Large.jpeg";
import pembentukan2Ravalen102 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Ravalen Virginia_102 Large.jpeg";
import pembentukan2Stevan41 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Stevan Antonius-41 Large.jpeg";
import pembentukan2Stevan29 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2_Stevan Antonius-29 Large.jpeg";
import pembentukan2Thirza84 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2-Thirza-84 Large.jpeg";
import pembentukan2Thirza9 from "../../Assets/Pembentukan-Hari-2-Revisi/Pembentukan Hari 2-Thirza-9 Large.jpeg";

const hariPembentukan2 = [
  { id: 1, img: pembentukan2Bernice78 },
  { id: 2, img: pembentukan2Stevan81 },
  { id: 3, img: pembentukan2Andrew163 },
  { id: 4, img: pembentukan2Andrew115 },
  { id: 5, img: pembentukan2Cinta116 },
  { id: 6, img: pembentukan2Kenzie258 },
  { id: 7, img: pembentukan2Cinta77 },
  { id: 8, img: pembentukan2Devin196 },
  { id: 9, img: pembentukan2Devin299 },
  { id: 10, img: pembentukan2Johan92 },
  { id: 11, img: pembentukan2Johan118 },
  { id: 12, img: pembentukan2Kelvin273 },
  { id: 13, img: pembentukan2Kelvin297 },
  { id: 14, img: pembentukan2Bernice108 },
  { id: 15, img: pembentukan2Kenzie264 },
  { id: 16, img: pembentukan2Kenzie314 },
  { id: 17, img: pembentukan2Kia13 },
  { id: 18, img: pembentukan2Kia31 },
  { id: 19, img: pembentukan2Ravalen095 },
  { id: 20, img: pembentukan2Ravalen102 },
  { id: 21, img: pembentukan2Stevan41 },
  { id: 22, img: pembentukan2Stevan29 },
  { id: 23, img: pembentukan2Thirza84 },
  { id: 24, img: pembentukan2Thirza9 }
];

export default hariPembentukan2;